export default __webpack_public_path__ + "static/media/location.fae34fc3.svg";